import { setUpdateAssistant } from "../../store/slices/assistantSlice";

export const extractTime = (dateTimeStr) => {
  if (!dateTimeStr) return "";
  const parts = dateTimeStr.split(" ");
  return parts.length > 1 ? parts[1] : dateTimeStr;
};
export const handleSetEditMode = (dispatch, assistant) => {
  let data = {
    ...assistant,
    settings: {
      ...assistant.settings,
      responseDelay: assistant.responseDelay || 15,
      startWorkTime:
        extractTime(assistant.settings.startWorkTime) || "00:00:00",
      endWorkTime: extractTime(assistant.settings.endWorkTime) || "00:00:00",
    },
  };
  dispatch(setUpdateAssistant(data));
};
